import { render } from "./AreaTematicaCard.vue?vue&type=template&id=67c3eec3"
import script from "./AreaTematicaCard.vue?vue&type=script&lang=ts"
export * from "./AreaTematicaCard.vue?vue&type=script&lang=ts"
script.render = render

export default script